{
  "clear": "Vymazat",
  "invalid": "(neplatné)",
  "loading": "Načítání...",
  "noResults": "Žádné výsledky"
}
